import { HttpRequestMethodTypes, HttpStatusCode, JSON_CONTENT_TYPE_HEADER } from 'types';
import { FetchOptions } from 'types/fetchWithRetry';
import { SearchParameters } from 'data/conversational-search/types';
import { fetchWithRetry } from 'utils/fetchWithRetry';
import { TenantId } from '@tenants/types';

interface LoadConversationalSearchDataParams {
  jwt: string;
  tenantId: TenantId;
}

export const loadConversationalSearchData = async ({
  jwt,
  tenantId,
}: LoadConversationalSearchDataParams): Promise<SearchParameters | null> => {
  try {
    const options: FetchOptions = {
      method: HttpRequestMethodTypes.GET,
      headers: {
        ...JSON_CONTENT_TYPE_HEADER,
        Authorization: `Bearer ${jwt}`,
      },
    };

    const response = await fetchWithRetry(`/api/conversational-search/load?tenantId=${tenantId}`, options);
    
    if (!response.ok) {
      if (response.status === HttpStatusCode.NOT_FOUND) {
        // No saved search data found - this is normal for new users
        return null;
      }
      console.error('Error loading conversational search data:', response.status);
      return null;
    }
    
    const data = await response.json();
    return data.searchParams || null;
  } catch (error) {
    console.error('Error loading conversational search data:', error);
    return null;
  }
};
